import React from 'react'
import { WidgetContent, Toggle, TextField, Divider } from '@duik/it'
import CreateNewModal from '../UI/CreateNewModal'
import { ModalButton } from '../UI/ModalButton'
import FormInputGroup from '../UI/FormInputGroup'

const ViewHaul = ({
  viewStep,
  materialList,
  setViewStep,
  haulDetail: {
    _id,
    haulType,
    haulId,
    pickUpSite,
    dropOffSite,
    project,
    material,
    materials,
    volume,
    poNumber,
    siteContact,
    superIntendant,
    quantity,
    driverConfirmMaterial,
    driverEnterWeight,
    driverCaptureTicket,
    notes,
    companyId: haulCompanyId,
    procoreCostCode
  },
  haulDetailModalToggle,
  createOrEditHaulModalToggle,
  companyId,
  isProcoreAvailable
}) => {
  const handleEditClick = () => {
    if (!quantity) {
      return alert('Please contact HaulR Support for assistance with editing this haul')
    }
    haulDetailModalToggle(_id)
    createOrEditHaulModalToggle('edit', _id)
  }

  const materialText =
    haulCompanyId === companyId
      ? materials
        ? materials.reduce((allMaterials, mat, index) => {
            const materialName =
              typeof mat === 'object'
                ? mat.name
                : (materialList.find(m => m._id === mat) || {}).name || 'Unknown'
            return index === 0 ? materialName : `${allMaterials} | ${materialName}`
          }, '')
        : material
      : material

  return (
    <CreateNewModal title={haulId} handleCloseModal={haulDetailModalToggle}>
      <Divider />
      <form>
        <WidgetContent
          style={{
            height: '420px',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            padding: 0,
            overflowY: 'scroll',
            overflowX: 'hidden'
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'baseline',
              width: '100%',
              padding: '0 30px',
              paddingBottom: '30px',
              boxSizing: 'border-box'
            }}
          >
            {/* TODO: Add 'Driver Instructions' when step 2 is added */}
            {['General Details', 'Additional Details'].map((tabHeader, index) => (
              <h4
                style={{
                  color: viewStep === index ? '#3E3F42' : '#9EA0A5',
                  borderBottom: viewStep === index ? '3px solid #289C91' : '',
                  cursor: 'pointer'
                }}
                onClick={() => setViewStep(index)}
                key={index}
              >
                {tabHeader}
              </h4>
            ))}
          </div>
          {viewStep === 0 && (
            <div style={{ paddingTop: '20px' }}>
              <div style={{ padding: '0 30px' }}>
                <FormInputGroup>
                  <TextField
                    className="fullWidthInputBox"
                    label="Haul Type"
                    name="haulType"
                    value={
                      haulType === 'export'
                        ? 'I am exporting materials offsite'
                        : 'I am importing materials onsite'
                    }
                    disabled
                  />
                </FormInputGroup>

                <FormInputGroup direction="horizontal">
                  <div style={{ marginTop: '10px' }}>
                    <TextField
                      className="halfWidthInputBox"
                      label="Haul ID"
                      name="haulId"
                      value={haulId}
                      maxLength={20}
                      disabled
                    />
                  </div>
                  <div style={{ marginTop: '10px' }}>
                    <TextField
                      className="halfWidthInputBox"
                      label="Project"
                      name="project"
                      value={project.projectName}
                      disabled
                    />
                  </div>
                </FormInputGroup>
                <FormInputGroup>
                  <div style={{ paddingTop: '30px' }}>
                    <TextField
                      className="fullWidthInputBox"
                      label="Pick Up Site"
                      name="project"
                      value={pickUpSite.siteName}
                      disabled
                    />
                  </div>
                </FormInputGroup>
                <FormInputGroup>
                  <div style={{ paddingTop: '10px' }}>
                    <TextField
                      className="fullWidthInputBox"
                      label="Drop Off Site"
                      name="dropOffSite"
                      value={dropOffSite.siteName}
                      disabled
                    />
                  </div>
                </FormInputGroup>

                <FormInputGroup direction="horizontal">
                  <div style={{ paddingTop: '30px' }}>
                    <TextField
                      className="halfWidthInputBox"
                      label="Material"
                      name="material"
                      value={materialText}
                      disabled
                    />
                  </div>
                  <div style={{ paddingTop: '30px' }}>
                    <TextField
                      className="halfWidthInputBox"
                      label="Quantity"
                      name="quantity"
                      value={
                        quantity && quantity.defaultMaterialQuantity ? 'Default' : 'From Ticket'
                      }
                      disabled
                    />
                  </div>
                </FormInputGroup>

                {isProcoreAvailable && procoreCostCode && (
                  <div style={{ paddingTop: '30px' }}>
                    <FormInputGroup>
                      <TextField
                        className="fullWidthInputBox"
                        label="Procore Cost Code"
                        name="procoreCostCode"
                        value={procoreCostCode.full_code || ''}
                        disabled
                      />
                    </FormInputGroup>
                  </div>
                )}
              </div>
            </div>
          )}

          {viewStep === -1 && (
            <div style={{ paddingTop: '20px' }}>
              <div style={{ padding: '0 30px' }}>
                <Toggle
                  label="Confirm Material"
                  name="driverConfirmMaterial"
                  description="The driver will be asked to confirm the material for each load"
                  value={driverConfirmMaterial}
                  defaultChecked={driverConfirmMaterial}
                  disabled
                />
                <Toggle
                  label="Enter weight"
                  description="The driver will be asked to enter the weight of each load"
                  disabled
                  value={driverEnterWeight}
                  defaultChecked={driverEnterWeight}
                />
                <Toggle
                  label="Capture Ticket"
                  description="The driver will be asked to take aphoto of each ticket (beta)"
                  disabled
                  value={driverCaptureTicket}
                  defaultChecked={driverCaptureTicket}
                />
              </div>
              <div style={{ padding: '30px' }}>
                <div>
                  <span className="uik-content-title__wrapper">
                    ADDITIONAL INSTRUCTIONS FOR DRIVER (OPTIONAL)
                  </span>
                </div>
                <textarea
                  className="fullWidthInputBox uik-input__input"
                  label="Notes"
                  name="notes"
                  style={{ height: '118px', resize: 'none' }}
                  value={notes}
                  disabled
                />
              </div>
            </div>
          )}

          {/* TODO: Change viewStep to 2 when second step is added */}
          {viewStep === 1 && (
            <div style={{ paddingTop: '20px' }}>
              <div style={{ padding: '0 30px' }}>
                <FormInputGroup>
                  <TextField
                    className="fullWidthInputBox"
                    label="PO Number"
                    name="poNumber"
                    value={poNumber}
                    disabled
                  />
                </FormInputGroup>

                <FormInputGroup>
                  <div style={{ paddingTop: '30px' }}>
                    <TextField
                      className="fullWidthInputBox"
                      label="Site Contact"
                      name="prsiteContactoject"
                      value={siteContact ? `${siteContact.firstName} ${siteContact.lastName}` : ''}
                      disabled
                    />
                    <div style={{ paddingTop: '10px' }}>
                      <TextField
                        className="fullWidthInputBox"
                        label="Superintendent"
                        name="superIntendant"
                        value={
                          superIntendant
                            ? `${superIntendant.firstName} ${superIntendant.lastName}`
                            : ''
                        }
                        disabled
                      />
                    </div>
                  </div>
                </FormInputGroup>
              </div>
            </div>
          )}
        </WidgetContent>
        <div style={{ display: 'flex' }}>
          <WidgetContent
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              border: 'none',
              width: '482px'
            }}
          >
            <div style={{ width: '83px' }}>
              <ModalButton
                buttonStyle="tertiary"
                name="Edit"
                onClick={handleEditClick}
                disabled={haulCompanyId !== companyId}
              />
            </div>
            <div style={{ width: '83px' }}>
              <ModalButton success name="OK" onClick={haulDetailModalToggle} />
            </div>
          </WidgetContent>
        </div>
      </form>
    </CreateNewModal>
  )
}

export default ViewHaul
